// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nTULQrKtNfUWfPh7ZW5X{justify-content:space-between;align-items:flex-start;display:flex}.nTULQrKtNfUWfPh7ZW5X .NkkDlcveqiIIQCx1h01Z{flex-direction:column;gap:12px;display:flex}.e12eh4cTr0SiFjznSKsk{width:109px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `nTULQrKtNfUWfPh7ZW5X`,
	"left": `NkkDlcveqiIIQCx1h01Z`,
	"guideButton": `e12eh4cTr0SiFjznSKsk`
};
export default ___CSS_LOADER_EXPORT___;
